"use client";

import { useEffect, useState } from "react";
import { useParams, usePathname } from "next/navigation";
import Link from "next/link";
import Clock from "@/public/icon/cl.svg";
import Pin from "@/public/icon/pinn.svg";
import Phone from "@/public/icon/ph.svg";
import Video from "@/components/Video/Video";
import http from "@/libs/config/http";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
import GoogleMap from "@/components/GoogleMap/GoogleMap";
const StoreList = ({ item, t }) => {
  const [stores, setStores] = useState(null);
  const [activeStore, setActiveStore] = useState(null);
  const { lang, stores: currentStore } = useParams();
  const pathname = usePathname();
  const [page_meta, setPageMeta] = useState({});
  const [breadCrumb, setBreadCrumb] = useState([]);
  useEffect(() => {
    if (!currentStore) return;

    const fetchData = async () => {
      try {
        const resp = await http(`stores/show/${currentStore}?lang=${lang}`, {
          method: "GET",
        });
        setStores(resp?.data);
        setPageMeta(resp?.page_meta || {});
        setBreadCrumb(resp?.page_meta?.breadcrumbs || []);
      } catch (err) {
        console.error("Data almaqda xəta:", err);
      }
    };

    fetchData();
  }, [currentStore, lang]);

  return (
    <div className="container">
      <BreadCrumb breadCrumb={breadCrumb} />
      <div className="title">
        <h1>{stores?.title}</h1>
      </div>
      <div className="row">
        <div className="xl-3 lg-3 md-3 sm-12 classStore">
          <div className="storesBar">
            {item?.map((storeItem) => {
              const linkHref = `/${lang}/stores/${storeItem.alias}`;
              const isActive = pathname === linkHref;
              return (
                <Link
                  key={storeItem.alias}
                  href={`/${lang}/stores/${storeItem.alias}`}
                  className={isActive ? "active" : ""}
                >
                  {storeItem.title}
                </Link>
              );
            })}
          </div>
          {/* <StoreList links={item} /> */}
        </div>
        <div className="xl-9 lg-9 md-9 sm-12">
          <div className="storeRow">
            <div className="row">
              <div className="xl-4 lg-4 md-4 sm-12">
                <div className="contactCard">
                  <div className="contactCardInner">
                    <span>{stores?.addresses}</span>
                    <p>{t["forms.address"]}</p>
                    <Pin />
                  </div>
                </div>
              </div>
              <div className="xl-4 lg-4 md-4 sm-6">
                <div className="contactCard">
                  <div className="contactCardInner">
                    {stores?.numbers?.map((number) => (
                      <Link href={`tel:${number}`} key={number}>
                        {number}
                      </Link>
                    ))}
                    <p>{t["forms.numbers"]}</p>
                    <Phone />
                  </div>
                </div>
              </div>
              <div className="xl-4 lg-4 md-4 sm-6">
                <div className="contactCard">
                  <div className="contactCardInner">
                    {stores?.work_hours?.map((work_hour, index) => {
                      return <span key={index}>{work_hour.hours}</span>;
                    })}
                    <p>{t["forms.work_hours"]}</p>
                    <Clock />
                  </div>
                </div>
              </div>
              <div className="xl-12 lg-12 md-12 sm-12">
                <Video item={stores} />
                <GoogleMap item={stores} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreList;
